module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_2017-177a412f7a6a41f9afacc887a0777f81.webp";